import { get, post } from "../services/api";

export const SetHomeContentAdded = (data) => ({
    type: "INIT_HOME_LAYOUT",
    data: data,
});

export const SetPageContent = (data) => ({
    type: "INIT_PAGE_LAYOUT",
    data: data,
});

export const cachePageContent = (slug, data) => ({
    type: "CACHE_PAGE_CONTENT",
    slug,
    data,
});

export const SetMetaData = (data) => ({
    type: "INIT_META_DATA",
    data: data,
});

export const homeLayoutContent = () => {
    return (dispatch) => {
        return get("get/home").then(({ data }) => {
            if (Object.keys(data).length) {
                dispatch(SetHomeContentAdded(data));
                if (data.page_data.page_meta_data) {
                    dispatch(SetMetaData(data.page_data.page_meta_data));
                }
            }
            return data;
        });
    };
};

export const PageContent = (parms) => {
    let requestData = {
        slug: "/" + parms,
    };
    return (dispatch, getState) => {
        // Check cache first
        const { page_cache } = getState().contents;
        if (page_cache && page_cache[parms]) {
            const cachedData = page_cache[parms];
            dispatch(SetPageContent(cachedData));
            if (cachedData.page_data.page_meta_data) {
                dispatch(SetMetaData(cachedData.page_data.page_meta_data));
            }
            return Promise.resolve(cachedData);
        }

        return get("get/page", requestData).then(({ data }) => {
            if (Object.keys(data).length) {
                dispatch(SetPageContent(data));
                dispatch(cachePageContent(parms, data));
                if (data.page_data.page_meta_data) {
                    dispatch(SetMetaData(data.page_data.page_meta_data));
                }
            }
            return data;
        });
    };
};

export const SetNewsContent = (data) => ({
    type: "INIT_NEWS_LAYOUT",
    data: data,
});

export const NewsContent = (parms) => {
    let requestData = {
        slug: "/" + parms,
    };
    return (dispatch) => {
        return get("get/web_news", requestData).then(({ data }) => {
            if (Object.keys(data).length) {
                dispatch(SetNewsContent(data));
                const metadata = {
                    meta_title: data.news_data.title,
                    meta_description: data.news_data.short_description,
                    meta_keywords: "Tanin Group",
                };
                dispatch(SetMetaData(metadata));
            }
            return data;
        });
    };
};

export const getGlobalSearch = (keyword) => {
    return (dispatch) => {
        return post("global-search", { keyword }).then(({ data }) => {
            return data;
        });
    };
};

export const Search = (query) => {
    return (dispatch) => {
        return get("get/search", { search_query: query }).then(({ data }) => {
            return data;
        });
    };
};
